/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClusterMetricsId
 */
export interface ClusterMetricsId {
    /**
     * 
     * @type {number}
     * @memberof ClusterMetricsId
     */
    id: number;
}

/**
 * Check if a given object implements the ClusterMetricsId interface.
 */
export function instanceOfClusterMetricsId(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function ClusterMetricsIdFromJSON(json: any): ClusterMetricsId {
    return ClusterMetricsIdFromJSONTyped(json, false);
}

export function ClusterMetricsIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClusterMetricsId {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

export function ClusterMetricsIdToJSON(value?: ClusterMetricsId | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}

